import { IncomeType } from "@prisma/client-generated";
import { z } from "zod";

export const incomeSchemaCreate = z.object({
  description: z.string().nullish(),
  year: z.number().int().positive(),
  valueInCents: z.number().int().min(0),
  incomeType: z.nativeEnum(IncomeType),
  overtimePayInCents: z.number().int().min(0).nullish(),
  tipsInCents: z.number().int().min(0).nullish(),
  currency: z.string().nullish(),
});

export const incomeSchemaUpdate = incomeSchemaCreate.partial();

export type IncomeUpsertData = z.infer<typeof incomeSchemaUpdate> & {
  id?: string | undefined;
};
